export class Warehouse {
  cantidad: number;
  // fecha_ingreso: Date;
  fecha_ingreso: string;
  precio_compra: string;
  precio_venta: string;
  producto_id: number;
  nro_comprobante: string;
  // nombre: string;
  // foto: string;
  // stock: string;
  // existencia:string;
}
